<n-data-table
    #dt
    [columnDefs]="tableColumnDefs"
    [config]="tableConfig"
    [data]="data"
    [loading]="loading"
    id="port-group-detail-port-table"
    style="height: calc(100% - 55px)">
</n-data-table>
